import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import * as React from "react";
import { addDisplayName } from "../../Infra/display-name";
import { HXPageHeader, HXPageSubtabs, HXPageTitle } from "../HXDesktopPage";
import { HXTab } from "../HXTab";
export const GlobalAdminReportsSubtabs = observer((props) => {
    var _a;
    const manager = props.container.globalAdminUIManager;
    return (_jsxs(_Fragment, { children: [_jsx(HXPageHeader, { children: _jsx(HXPageTitle, { children: "Reports" }) }), _jsx(HXPageSubtabs, { value: (_a = manager.currentReportsPage) !== null && _a !== void 0 ? _a : "RUN", onChange: (_event, page) => manager.setCurrentReportsPage(page), children: manager.reportsPagesToShow.map(({ page, label }) => (_jsx(HXTab, { value: page, label: label, analyticsId: `reports-${page.toLowerCase()}` }, page))) })] }));
});
addDisplayName(GlobalAdminReportsSubtabs, "GlobalAdminReportsSubtabs");
